import type { CreditPackagePageVo, PlanPageVo } from "@/api";
import { api } from "@/api";
import { isAxiosError } from "axios";

export async function fetchActivePlans(): Promise<PlanPageVo | null> {
  try {
    const response = await api.plans.queryActivePlans();
    return response.data ?? null;
  } catch (error) {
    const errorStatus = isAxiosError(error)
      ? error.response?.status || "unknown"
      : "unknown";
    console.error("Failed to fetch active plans:", {
      error,
      status: errorStatus,
    });
    return null;
  }
}

export async function fetchCreditPackages(): Promise<CreditPackagePageVo | null> {
  try {
    const response = await api.credits.getCredit();
    return response.data ?? null;
  } catch (error) {
    const errorStatus = isAxiosError(error)
      ? error.response?.status || "unknown"
      : "unknown";
    console.error("Failed to fetch credit packages:", {
      error,
      status: errorStatus,
    });
    return null;
  }
}
